import * as React from "react";
const SvgUspCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 12, viewBox: "0 0 17 12", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.05 8.90678L14.8069 0.149887L16.2211 1.5641L6.05 11.7352L0.235893 5.9211L1.65011 4.50689L6.05 8.90678Z" }));
export default SvgUspCheck;
